import React from "react";
import { ChatConfigData, MessageConfigData, ProjectVoting, VotesConfigData } from "../Shared/Party/PartyConfigData";
import { UIConfigContext } from "./UIConfigContext";
import { StateManagerContext } from "./StateManagerContext";
import { getChat, LiveMessageFeed, LiveMessageFeedProps, RenderMessageForFeed } from "./LiveMessageFeed";
import { CommentButtonPanel, CommentButtonPanelProps } from "./CommentButtonPanel";
import { StateManager } from "./PartyState";
import { ActionHandler } from "./ActionButton";

export type ChatDisplayProps = {
  chatId: string;
  chat?: ChatConfigData;
  height: number;
  displayButtons?: boolean;
  timeBasis: number;
}

export const ChatDisplay = ({ chatId, chat, height, displayButtons, timeBasis }: ChatDisplayProps): JSX.Element => {
  const initFuncs = React.useRef<boolean>(false);
  const uiConfig = React.useContext(UIConfigContext);
  const stateManager = React.useContext(StateManagerContext);
  const [userMessage, setUserMessage] = React.useState<MessageConfigData | null>(null);
  const [userMessagePanel, setUserMessagePanel] = React.useState<JSX.Element | null>(null);
  const resizeChatArea = React.useRef<boolean>(false);
  const [userMessagePanelHeight, setUserMessagePanelHeight] = React.useState<number>(0);

  const getChatVotes = (): VotesConfigData => {
    const chatInstance: ChatConfigData = chat === undefined ? getChat(stateManager, chatId) : chat;
    if (chatInstance.voting === undefined) {
      chatInstance.voting = {
        itemId: chatInstance.itemId + '_voting',
        impressions: 0,
        likes: 0,
        comments: 0,
        created: Date.now() - 1000,
        updated: 0
      }
      return chatInstance.voting;
    }
    else
      return chatInstance.voting;
  }

  

  
  const showButtons = displayButtons ?? true;

  const userMessageHandler = (userMessage: MessageConfigData) => {
    console.log("LiveMessageFeed: User message call back");
    setUserMessage(userMessage);
    setUserMessagePanel(RenderMessageForFeed(userMessage, uiConfig.fanboxColor('darkGray'), uiConfig.fontBase, stateManager.user().fanbox.id, 1111111, uiConfig.showEventOverlay));
    resizeChatArea.current = true;
  }


 

  if (!initFuncs.current) {
    initFuncs.current = true;
    uiConfig.setUserMessageHandler(userMessageHandler);
    //stateManager.addNotifyContextUpdateFunction(Date.now(), updateFunction)
  }

  React.useEffect(() => {
    if (userMessagePanel !== null && resizeChatArea.current) {
      resizeChatArea.current = false;

      const key = userMessagePanel.key;
      var height = 0;
      if (key !== null) {
        const element = document.getElementById(key);
        const rect = element?.getBoundingClientRect();
        if ((rect !== null) && (rect !== undefined)) {
          height = rect.height;
        }
      }
      setUserMessagePanelHeight(height);
    }
    else if (resizeChatArea.current) {
      setUserMessagePanelHeight(0);
    }
  })

  const commentClickHandler: ActionHandler = (_action): boolean => {
    const data: { [key: string]: string } = { id: chatId, chatId: chatId };
    uiConfig.showEventOverlay('reply', data);
    return true;
  }

  const buttonProps: CommentButtonPanelProps = {
    width: uiConfig.width,
    height: 2.0 * uiConfig.fontBase,
    voting: getChatVotes(),
    keyIndex: "ChatDisplay_" + chatId + "_Buttons_",
    commentButton: userMessage === null,
    commentClickHandler, 
    useSignInOverlay : true
  }

  const feedProps: LiveMessageFeedProps = {
    chatId: chatId ?? '',
    chat: chat !== undefined ? chat : {
      itemId: '',
      chatType: 'comment',
      messages: [],
      threads: [],
      startTime: 0,
      endTime: 0
    },
    height: height - userMessagePanelHeight - (showButtons ? 2 * uiConfig.fontBase : 0),
    currentUser: stateManager.user().fanbox.id,
  }

  return (<div style={{
    width: uiConfig.width + "px",
    minWidth: uiConfig.width + "px",
    maxWidth: uiConfig.width + "px",
    height: height + "px",
    minHeight: height + "px",
    maxHeight: height + "px",
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: uiConfig.fanboxColor('darkGray')

  }}>
    {showButtons && <CommentButtonPanel {...buttonProps} />}
    {(userMessagePanel !== null) && userMessagePanel}
    <LiveMessageFeed {...feedProps} key={chatId + 'lmf'} />


  </div>)
};